// extracted by mini-css-extract-plugin
export default {"chatBoxList":"ChatContainer-module__chatBoxList--2b3f"};